<template>
  <div class="body-mobile">
    <div class="wrapper-body">
      <div class="wrapper-body__header">
        <nav-step :active="3"></nav-step>
      </div>
      <div class="wrapper-body__body">
        <div class="wrapper-body__body__title">
          <p>
            预报名成功
            <span>（3/3）</span>
          </p>
        </div>
        <div class="wrapper-body__body__container">
          <div class="bm_info_items" v-if="applyData" id="appData">
            <h2 class="sx-align-center" style="margin-top:.2rem;">资料提交成功</h2>
            <div class="_item">
              <span>预报名号：</span>
              <font>
                {{applyData.id}}
                <i>（请牢记预报名号）</i>
              </font>
            </div>
            <div class="_item">
              <span>审核机构：</span>
              <font>{{applyData.auditOrg}}</font>
            </div>
            <div class="_item">
              <span>状态：</span>
              <font style="font-weight: bold;color:rgb(255,114,0)">{{applyData.statusName}}</font>
            </div>
            <div class="_item" style="display: flex" v-if="applyData.status-0===3">
              <div class="_item__title">不通过原因：</div>
              <!--<font style="font-weight: bold;color:rgb(255,114,0);word-break: break-all">{{applyData.reason}}</font>-->
              <div style="flex:1;font-weight: bold;color:rgb(255,114,0);word-break: break-all">{{applyData.reason}}</div>
            </div>
            <div class="text-error" style="margin:0 .4rem;color:#aaa;white-space: pre-line;background-color: rgba(230, 247, 255, 1);padding: .3rem">
              <h1 style="font-size: .3rem;color:#999">注意事项：</h1>
              <p>{{precautions}}</p>
            </div>
          </div>
        </div>
      </div>
      <div style="color:#fff;margin-top:10px;font-size: 16px" @click="downloadCheckList">
        <md-icon name="card-bag"></md-icon>下载面试资料清单
      </div>
      <div class="wrapper-body__footer">
        <div class="box-btns" v-if="applyData">
          <span class="button-primary" id="renderPdf" v-show="false">保存预报名号</span>
          <span class="button-primary" @click="onClickSaveBtn">保存预报名号（简历）</span>
          <!--<span-->
          <!--v-if="applyData.status === 0"-->
          <!--class="button-primary-inset"-->
          <!--@click="onClickChangeBtn">修改报名信息</span>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageBmInfo from '../index/mixins/page_bm_info';
  import { Icon } from 'mand-mobile'

  export default {
    mixins: [IndexCommon, MobileCommon, PageBmInfo],
    components: {Icon},
    data() {
      return {
        precautions:""
      }
		},
		async created() {
			// let self = this;
			// if (window.history && window.history.pushState) {
			// 	window.addEventListener('popstate', function() {
			// 		var hashLocation = location.hash; var hashSplit = hashLocation.split('#!/');
			// 		var hashName = hashSplit[1];
			// 		if (hashName !== '') {
			// 			var hash = window.location.hash; if (hash === '') {
			// 				// alert('後退按鈕點擊');
			// 				self.$router.push({
			// 					path: './index'
			// 				});
			// 		}
			// 		}
			// 	});
      // }
      let { error, data } = await this.$ajax.gateway(
      "/bm-teacher/ISignupProtocolApi_infoFree",
      {
        METHOD: "get",
        signupNoticeId: this.$route.query.signupNoticeId
      }
    );
      console.log("报名须知", error, data);
      if (data.code === 200) {
        // this.checkList = data.data.checkList;
        this.precautions = data.data.precautions
      }
		},
    methods: {
      async onClickSaveBtn(){
        // 【报名管理】导出个人报名表 #吴昂/2020-02-29#
        let {data} = await this.$ajax.gateway("/bm-teacher/ITeacherSignupApi_exportSingleFree", {
          "signupId": this.applyData.id
        });
        console.log(data.data);
        if(data.data.ossFileUrl){
          window.location.href = data.data.ossFileUrl;
        }else{
          this.$message.error('下载链接获取失败！');
        }
      },

      async downloadCheckList(){
        console.log('下载');
        // 下载资料清单 #吴昂/2020-03-05#
        let {data} = await this.$ajax.gateway("/bm-teacher/ITeacherSignupApi_downloadChecklist", {
          "METHOD": "get",
          "signupNoticeId": this.$route.query.signupNoticeId
        });
        console.log(data.data);
        if(data.data){
          window.location.href = data.data;
        }else{
          this.$message.error('下载链接获取失败！');
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
.body-mobile {
  .wrapper-body {
    .wrapper-body__body__container {
      padding: 0 0.1rem;
    }
  }
}

.bm_info_items {
  padding-bottom: 20px;

  h2 {
    color: #333;
  }

  ._item {
    font-size: 32px;
    color: #999999;
    line-height: 80px;

    ._item__title{
      width: 200px;
      text-align: right;
    }
    span {
      display: inline-block;
      width: 200px;
      text-align: right;
    }

    font {
      color: #333;
      font-weight: 400;

      i {
        font-weight: 100;
        font-style: normal;
        font-size: 24px;
      }
    }

    &.sub_item {
      line-height: 44px;
      font-size: 24px;
      color: #666;

      span {
        font-size: 24px;
        color: #999;
      }
    }

    &.type_item {
      font {
        font-weight: 400;
        color: #39bac0;
      }
    }
  }

  .err_message {
    color: #ff0000;
    font-size: 20px;
    line-height: 36px;
    text-align: center;
    padding: 120px 0 0;
  }

  .loading_message {
    color: #999;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    padding: 140px 0 0;
  }
}
</style>
